/** Formik validation  */
var objIsRecord = function (obj) {
    return !!obj && typeof obj === 'object';
};
/**
 * getValidationErrors returns an array of error strings listed from a FormikErrors input object, keyed by property
 *
 * Params:
 * - errors: a FormikErrors input object
 * - prefix: used internally
 */
export var getValidationErrors = function (errors, prefix) {
    if (prefix === void 0) { prefix = ''; }
    return Object.keys(errors).reduce(function (listedErrors, key) {
        var error = errors[key];
        if (objIsRecord(error))
            listedErrors.push.apply(listedErrors, getValidationErrors(error, "".concat(prefix).concat(key, ".")));
        else if (error)
            listedErrors.push("".concat(prefix).concat(key, ": ").concat(error));
        return listedErrors;
    }, []);
};
